import React from 'react';

type Props = {
  id?: string;
  children: React.ReactNode;
  className?: string;
};

/** Lightweight section wrapper — background comes from the single page-level HeroBackground */
export function LandingSectionShell({ id, children, className = '' }: Props) {
  return (
    <section id={id} className={`relative z-10 py-20 sm:py-28 ${className}`}>
      {children}
    </section>
  );
}
